<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          ref="settlementForm"
          :model="settlement"
          class="box"
          label-width="100px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.title')">
                  {{ settlement.title }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.couriers')">{{
                  settlement.courierName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('deliverCheck.quantity')">{{
                  settlement.quantity
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('deliverCheck.successQuantity')">{{
                  settlement.successQuantity
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('deliverCheck.warnQuantity')">{{
                  settlement.warnQuantity
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('deliverCheck.failQuantity')">{{
                  settlement.failQuantity
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.owner')">{{
                  settlement.userName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  settlement.createAt
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="settlement.verifyAt != null">
              <el-col :span="8">
                <el-form-item :label="$t('settlement.settlerNameDelivery')">{{
                  settlement.verifyName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.verifyAt')">{{
                  settlement.verifyAt
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import MCourierCost from "@/api/mCourierCost.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      settlement: {},
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.loadingStart();
    MCourierCost.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.settlement = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>